<template>
  <qx-card-form title="外调车承包车成本">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    >
      <section slot="split1"></section>
      <section slot="split2"></section>
      <section slot="split3"></section>
      <section slot="crossDistrictCostList" slot-scope="prop">
        <section>
          <CrossDistrictItem
            v-for="(item, index) in prop.form.crossDistrictCostList"
            :key="index"
            :index="index"
            :cclaId="item.cclaId"
            :lineId="item.lineId"
            :desProvince="item.desProvince"
            :desProvinceName="item.desProvinceName"
            :desCity="item.desCity"
            :desCityName="item.desCityName"
            :desCounty="item.desCounty"
            :desCountyName="item.desCountyName"
            :superzoneFee="item.superzoneFee"
            v-model="item.superzoneFee"
            @handleDeleteItem="handleDeleteItem"
          />
        </section>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  selectSysStaticDataByCodeType,
} from 'api';
import CrossDistrictItem from './components/crossDistrict';
export default {
  components: {
    CrossDistrictItem,
  },
  data () {
    return {
      // 所有省市区
      addressList: [],
      baseForm: {
        crossDistrictOutwardOptions: [],
        costChargeModeOptions: [],
        inline: true,
        form: [
          {
            label: '计费方式',
            value: 'costChargeMode',
            placeholder: '请选择计费方式',
            type: 'radio',
            default: '0',
            onChange: () => {
              this.handleChangeIncomeChargeMode();
            },
          },
          {
            value: 'split1',
            allCustom: true,
          },
          {
            label: '基本运费',
            value: 'costBasicShow',
            placeholder: '请输入基本运费',
            type: 'input',
            unit: '元',
          },
          {
            label: '基本运费',
            value: 'costBasic',
            type: 'input',
            hide: true,
          },
          {
            label: '基本点数',
            value: 'costBasicCount',
            placeholder: '请输入基本点数',
            type: 'input',
            remark: '基本运费包含配送点的个数',
          },
          {
            label: '点费',
            value: 'costRegionalCostShow',
            placeholder: '请输入点费',
            type: 'input',
            unit: '元/个',
            remark: '超出基本点数后按超出个数收费',
          },
          {
            label: '点费',
            value: 'costRegionalCost',
            type: 'input',
            hide: true,
          },
          {
            value: 'split2',
            allCustom: true,
          },
          {
            label: '超区区县',
            value: 'crossDistrictOutward',
            placeholder: '请选择超区区县',
            type: 'cascader',
            props: { multiple: true },
            collapseTags: true,
            onChange: (data) => {
              this.handleUnselectedChange();
            },
            hide: true,
          },
          {
            label: '基本里程',
            value: 'costMileageBasic',
            placeholder: '请输入基本里程',
            type: 'input',
            unit: '公里',
            remark: '基本运费包含里程',
            hide: true,
          },
          {
            label: '单公里运费',
            value: 'costMileageSinglekmShow',
            placeholder: '请输入单公里运费',
            type: 'input',
            hide: true,
          },
          {
            label: '单公里运费',
            value: 'costMileageSinglekm',
            type: 'input',
            hide: true,
          },
          {
            value: 'split3',
            allCustom: true,
          },
          {
            value: 'crossDistrictCostList',
            slot: true,
            default: [],
          },
        ],
        rules: {
          costChargeMode: [
            { required: true, message: '请选择计费方式', trigger: 'submit' },
          ],
          costBasic: [
            { required: true, message: '请输入基本运费', trigger: 'submit' },
          ],
          costBasicCount: [
            { required: true, message: '请输入基本点数', trigger: 'submit' },
          ],
          costRegionalCost: [
            { required: true, message: '请输入点数', trigger: 'submit' },
          ],
        },
      },
    };
  },
  methods: {
    async getOptions () {
      if (!this.baseForm.costChargeModeOptions.length) {
        const costChargeModeOptions = await selectSysStaticDataByCodeType({
          codeType: 'CITY_LINE_CHARGR_MODE',
          hasAll: true,
        });
        this.baseForm.costChargeModeOptions = costChargeModeOptions.filter((item) => item.value !== '-1');
      }
    },

    // 获取所有的省市区
    setAddressInfo (data) {
      this.addressList = data;
    },

    // 获取超区区县列表
    getCrossDistrictInfo (crossDistrictOutward) {
      let crossDistrictInfo = {};
      for (let province of this.addressList) {
        for (let city of province.children) {
          if (city.value === crossDistrictOutward[0]) {
            for (let district of city.children) {
              if (district.value === crossDistrictOutward[1]) {
                crossDistrictInfo = {
                  lineType: 2,
                  desProvince: province.value,
                  desProvinceName: province.label,
                  desCity: city.value,
                  desCityName: city.label,
                  desCounty: district.value,
                  desCountyName: district.label,
                  superzoneFee: '',
                };
              }
            }
          }
        }
      }

      const crossDistrictCostList = this.$refs.baseForm.getVal('crossDistrictCostList');

      // 这里主要是为了让各个项塞进去 id 和 超区费用
      if (crossDistrictCostList.length) {
        for (let item of crossDistrictCostList) {
          if (
            item.desProvince === crossDistrictInfo.desProvince &&
            item.desCity === crossDistrictInfo.desCity &&
            item.desCounty === crossDistrictInfo.desCounty
          ) {
            crossDistrictInfo.cclaId = item.cclaId;
            crossDistrictInfo.lineId = item.lineId;
            crossDistrictInfo.customerId = item.customerId;
            crossDistrictInfo.superzoneFee = item.superzoneFee + '';
          }
        }
      }
      return crossDistrictInfo;
    },

    // 设置未选择区县
    setUnSelectDistrict (data) {
      setTimeout(() => {
        this.baseForm.crossDistrictOutwardOptions = data;
      }, 50);
    },

    // 把收入信息中的内容覆盖到成本信息中
    copyValueToOutwardCar (data) {
      if (data.incomeBasicCount) {
        this.$refs.baseForm.setVal('costBasicCount', data.incomeBasicCount);
      }
      if (data.crossDistrictIncome) {
        this.$refs.baseForm.setVal('crossDistrictOutward', data.crossDistrictIncome);
        this.handleUnselectedChange();
      }
    },

    // 选择超区区县
    handleUnselectedChange () {
      const crossDistrictOutward = this.$refs.baseForm.getVal('crossDistrictOutward');
      const newIncomeList = [];
      if (crossDistrictOutward) {
        for (let item of crossDistrictOutward) {
          const crossDistrictInfo = this.getCrossDistrictInfo(item);
          newIncomeList.push(crossDistrictInfo);
        }
      }
      this.$refs.baseForm.setVal('crossDistrictCostList', newIncomeList);
    },

    // 选择计费方式
    handleChangeIncomeChargeMode () {
      const costChargeMode = this.$refs.baseForm.getVal('costChargeMode');
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
        names: ['crossDistrictOutward', 'crossDistrictCostList', 'costMileageBasic', 'costMileageSinglekmShow'],
      });
      if (Number(costChargeMode) === 0) {
        // 按点位，显示超区县区
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['crossDistrictOutward', 'crossDistrictCostList'],
        });
      } else if (Number(costChargeMode) === 1) {
        // 按里程，显示 基本里程 和 单公里运费
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: ['costMileageBasic', 'costMileageSinglekmShow'],
        });
      }
    },

    // 删除该选项
    handleDeleteItem (index) {
      const crossDistrictOutward = this.$refs.baseForm.getVal('crossDistrictOutward');
      crossDistrictOutward.splice(index, 1);
      this.$refs.baseForm.setVal('crossDistrictOutward', crossDistrictOutward);
      this.handleUnselectedChange();
    },

    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.crossDistrictOutward;
      }
      console.log(formData);
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        formData = {
          costChargeMode: formData.costChargeMode,
          costBasic: `${(formData.costBasicShow * 1000) / 10}`,
          costBasicCount: formData.costBasicCount,
          costRegionalCost: `${(formData.costRegionalCostShow * 1000) / 10}`,
          crossDistrictOutward: formData.crossDistrictOutward,
          costMileageBasic: formData.costMileageBasic,
          crossDistrictCostList: JSON.stringify(formData.crossDistrictCostList || []),
        };
        if (Number(formData.costChargeMode) === 1) {
          formData.costMileageSinglekm = `${(formData.costMileageSinglekmShow * 1000) / 10}`;
        }
      }
      return formData;
    },
    async init (data = {}) {

      await this.getOptions();

      if (data.costChargeMode === undefined) {
        data.costChargeMode = '0';
      } else {
        data.costChargeMode = String(data.costChargeMode);
      }

      if (data.costBasic) {
        data.costBasicShow = (data.costBasic) / 100;
      }

      if (data.costRegionalCost) {
        data.costRegionalCostShow = (data.costRegionalCost) / 100;
      }

      if (data.costMileageSinglekm) {
        data.costMileageSinglekmShow = (data.costMileageSinglekm) / 100;
      }

      if (data.subLinaArea && data.subLinaArea.length) {
        const crossDistrictOutward = [];
        const crossDistrictCostList = [];
        for (let item of data.subLinaArea) {
          if (item.lineType === 2) {
            crossDistrictOutward.push([item.desCity, item.desCounty]);
            crossDistrictCostList.push(item);
          }
        }
        data.crossDistrictOutward = crossDistrictOutward;
        data.crossDistrictCostList = crossDistrictCostList;
      } else {
        if (typeof data.crossDistrictCostList === 'string') {
          data.crossDistrictCostList = JSON.parse(data.crossDistrictCostList);
        }
      }

      this.$refs.baseForm.setVal(data);
      this.handleChangeIncomeChargeMode();
      this.handleUnselectedChange();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
